<template>
  <div
    class="flex flex-wrap w-full bg-grey-0 border border-grey-3 md:rounded mb-4 px-4 py-2 hover:border-blue-4 transition-colors transition-250"
  >
    <div
      class="w-1/2 flex justify-start text-sm text-grey-8"
    >Page {{ data.current_page }} of {{ data.last_page }}</div>
    <div class="w-1/2 flex justify-end">
      <router-link
        class="text-sm text-blue-9 hover:text-blue-7 mx-2"
        v-if="data.prev_page_url"
        :to="{name: route, query: {page: data.current_page - 1}}"
      >Prev</router-link>
      <router-link
        class="text-sm text-blue-9 hover:text-blue-7 mx-2"
        v-if="data.next_page_url"
        :to="{name: route, query: {page: data.current_page + 1}}"
      >Next</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "Pagination",
  props: {
    data: {
      required: true
    },
    route: {
      required: true
    }
  }
}
</script>
